jQuery( document ).ready( function ( $ ) {
	function TABTOGGLECONTENT( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-tab-toggle-content v2.2' )
		this.instance = thisInstance
		this.init()
	}

	TABTOGGLECONTENT.prototype.init = function () {
		const self = this
		const items = 'jtf__tabtoggleblock__items'
		const item = items + '__item'
		const blockName = $( self.instance ).find( '.' + items ).attr( 'data-blockname' )
		let itemName = $( self.instance ).find( '.' + item + '--selected' ).attr( 'data-itemname' )

		if ( '' != blockName && '' != itemName ) {
			self.hideAllContent( blockName, itemName )
		}

		$( self.instance ).on( 'click', '.' + item, function () {
			itemName = $( this ).attr( 'data-itemname' )

			$( self.instance ).find( '.' + item ).each( function () {
				$( this ).removeClass( item + '--selected' )
				$( this ).attr( 'aria-selected', false )
			} )
			$( this ).addClass( item + '--selected' )
			$( this ).attr( 'aria-selected', true )

			if ( '' != blockName && '' != itemName ) {
				self.hideAllContent( blockName, itemName )
			}
		} )

		// for panel left style set a css class on the link JTF Group Blocks
		const targetElement = $( '.jtf__tabtoggleblock--tabsleft' )
		targetElement.closest( '.col-12' ).addClass( 'jtf__tabtoggleblock--colcontainer' )
	}

	TABTOGGLECONTENT.prototype.hideAllContent = function ( blockName, itemName ) {
		const itemContent = 'jtf__tabtoggleblock__content'
		const blockNameClass = '.' + itemContent + '__blockname--' + blockName
		if ( 0 < $( blockNameClass ).length ) {
			const itemNameClass = '.' + itemContent + '__itemname--' + itemName
			$( blockNameClass ).hide()
			$( blockNameClass + itemNameClass ).fadeIn()
		}
	}

	if ( $( '.wp-admin' ).length > 0 ) {
		setTimeout( function () {
			new TABTOGGLECONTENT( $( this ) )

			if ( $( '.wp-block-jtf-jtf-tab-toggle-content' ).length > 0 ) {
				$( '.wp-block-jtf-jtf-tab-toggle-content' ).each(
					function () {
						new TABTOGGLECONTENT( $( this ) )
					},
				)
			}
		}, 1000 )
	} else {
		// wrap this in a check to see if the outer container even exists,
		// because that way we don't instntiate the code for this if its
		// not on the page
		if ( $( '.wp-block-jtf-jtf-tab-toggle-content' ).length > 0 ) {
			$( '.wp-block-jtf-jtf-tab-toggle-content' ).each(
				function () {
					new TABTOGGLECONTENT( $( this ) )
				},
			)
		}
	}
} )
